import React, { FC, PropsWithChildren } from 'react';
import { Elevation } from '../../../../components/Elevation';
import classes from './styles/backofficeWidget.module.scss';

type BackofficeWidgetProps = {
	dataTestId?: string;
};
export const BackofficeWidgetCard: FC<PropsWithChildren<BackofficeWidgetProps>> = ({ children, dataTestId }) => {
	return (
		<Elevation
			boxShadow='small'
			borderRadius='4px'
			className={classes.backofficeWidget}
			dataTestId={dataTestId}
		>
			{children}
		</Elevation>
	);
};
